// app/javascript/controllers/table_refresh_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	connect() {
		const targetTableId = this.element.dataset.targetTable;
		const frame = document.getElementById(targetTableId);

		if (frame) {
			frame.reload();
		}
	}
}
